export const ADD_ORDER_ITEM = 'ADD_ORDER_ITEM'
export const SET_ORDER_ITEM = 'SET_ORDER_ITEM'
export const REMOVE_ORDER_ITEM = 'REMOVE_ORDER_ITEM'
export const SET_ORDER_VALUE = 'SET_ORDER_VALUE'
export const RESET_ORDER = 'RESET_ORDER'
